import React from "react";

type LoadingSpinnerProps = {
	size?: "xs" | "sm" | "md" | "lg";
	inline?: boolean;
	className?: string;
};

const sizeToPx: Record<NonNullable<LoadingSpinnerProps["size"]>, number> = {
	xs: 12,
	sm: 16,
	md: 24,
	lg: 40
};

/** Renders an animated loading spinner with configurable size and inline/block display. */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
	size = "md",
	inline = false,
	className = ""
}) => {
	const dimension = sizeToPx[size] ?? sizeToPx.md;
	const wrapperClasses = inline
		? "inline-flex items-center justify-center"
		: "flex items-center justify-center";

	return (
		<div className={`${wrapperClasses} ${className}`}>
			<div
				className="animate-spin rounded-full border-2 border-slate-300 border-t-slate-900"
				style={{ width: dimension, height: dimension }}
				aria-label="Loading"
			/>
		</div>
	);
};
